import React, { memo, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import clsx from 'clsx';

import { brands, useBrand } from '@atc/brand';

import {
    Col,
    Select,
} from 'reaxl';
import {
    PromoCard,
} from 'reaxl-listing';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';
import srpSimilarListingsDuck from '@/ducks/srp/srpSimilarListingsDuck.js';

import useSrpNavigation from '@/hooks/useSrpNavigation';

function InventoryTransitionCardContainer({ searchRadius, isLastPage }) {
    const { isBrand } = useBrand();
    const isFordBranded = isBrand(brands.FORD_BRAND);

    const navigateToSrp = useSrpNavigation();
    const dispatch = useDispatch();
    const filtersValues = useSelector(srpFiltersDuck.selectors.getFiltersValues);
    const filtersOptions = useSelector(srpFiltersDuck.selectors.getFiltersOptions);
    const similarListings = useSelector(srpSimilarListingsDuck.selectors.getActiveInventory);

    // only show this copy when has results more than 0
    const headerText = "Pump the brakes! You've cruised through matches";
    const headerTextWithRadius = `${headerText} within ${searchRadius || 0} miles.`;
    const headerTxt = (searchRadius > 0) ? headerTextWithRadius : `${headerText}.`;
    const fordHeaderTxt = `Good news! We found ${similarListings.length} similar vehicles ahead.`;
    const fordTransitionSubText = isFordBranded && 'Keep cruising towards more cars nearby.';

    const applySearchRadiusChange = useCallback(async (event) => {
        dispatch(srpFiltersDuck.creators.applyFilterChange(event, filtersOptions?.searchRadius));

        navigateToSrp({ resetPagination: true, isNewSearch: false });
    }, [dispatch, navigateToSrp, filtersOptions?.searchRadius]);

    const renderExpandSearchRadius = (
        <div className={clsx(
            'col-xs-12',
            { 'margin-top-2': isFordBranded }
        )}
        >
            {fordTransitionSubText}
            <h4
                className={clsx(
                    'text-bold margin-bottom-2 text-size-300',
                    { 'margin-top-5 text-size-400': isFordBranded }
                )}
                id="transitionCard-radius"
            >
                Update your search distance
            </h4>
            <Select
                data-cmp="InventoryTransitionCardRadius"
                onChange={applySearchRadiusChange}
                options={filtersOptions?.searchRadius?.options}
                name={filtersOptions?.searchRadius?.name}
                value={filtersValues?.searchRadius}
                key="cardSearchRadius"
                aria-labelledby="card-search-distance-heading"
                labelProps={{
                    label: 'Radius',
                }}
                layout={isFordBranded ? 'insideLabel' : 'inside'}
            />

        </div>
    );

    const promoCardProps = isFordBranded ? {
        imgSrc: '/cm-api/content/static/img/placeholders/more-ahead.svg',
        imgHeight: '130px',
        heading: fordHeaderTxt,
    } : {
        subHeadingLevel: 2,
        panelSubHeadingClassName: 'text-blue-darkest margin-vertical-5',
        imgSrc: '/cm-api/content/static/img/marketextension/marketExtension.svg',
        imgHeight: '68px',
        heading: headerTxt,
    };

    return isLastPage && (
        <Col
            componentClass={PromoCard}
            xs={12}
            sm={4}
            data-cmp="InventoryTransitionCard"
            bodyClassName="padding-horizontal-3"
            className="display-flex"
            imgWidth="210px"
            uiContext="wallet"
            subText={renderExpandSearchRadius}
            {...promoCardProps}
        />
    );
}
export default memo(InventoryTransitionCardContainer);
